export const SET_DIALOG_SECTION = (state, dialogSection) => {
    state.dialogSection = dialogSection;
  };
  
  